import { call, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../../../constants/ActionTypes/AdminPortal/HardwareInclusiveCounter';
import { _ADMINISTRATOR_API_ENDPOINTS } from '../../../constants/AppConstants';
import { _CALLGETAPI } from '../../../api/apiHandler';
import i18next from 'i18next';

function _fetchHardwareInclusiveCounter(countryCode,PrinterType) {
    const endpoint = _ADMINISTRATOR_API_ENDPOINTS.HARDWARE_INCLUSIVE_COUNTER.FETCH;
    const payload = {
        params: {
            countryCode:countryCode,
            PrinterType:PrinterType
        }
    };
    return _CALLGETAPI(endpoint, payload)
        .then(response => response)
        .catch((error) => {
            throw error;
        });
}

function* handleInfo(action) {
    try {
        const countryCode = action.countryCode;
        const PrinterType = action.PrinterType;
        
        if (countryCode) {
            const result = yield call(_fetchHardwareInclusiveCounter, countryCode,PrinterType);
            yield put({ type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_SUCCESS, data: result });
            }
    } catch (e) {
        yield put({
            type: actionTypes.GET_HARDWARE_INCLUSIVE_COUNTER_FAILURE,
            message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.TECHNICAL_ERROR')
        });
    }
}

function* HardwareInclusiveCounter_FETCH() {
    yield takeEvery(actionTypes.GET_HARDWARE_INCLUSIVE_STOCK_COUNTER_INIT, handleInfo);
}

export default HardwareInclusiveCounter_FETCH;
